import axios from 'axios';

// Configuración de FileMaker desde variables de entorno
const API_URL = process.env.REACT_APP_FILEMAKER_API_URL;
const API_TOKEN = process.env.REACT_APP_FILEMAKER_API_TOKEN;

/**
 * Servicio de prueba para verificar conectividad con FileMaker
 */
class FileMakerTestService {
  /**
   * Prueba la conectividad básica con FileMaker Server
   */
  async testConnection() {
    try {
      console.log('🔍 Probando conexión con FileMaker...');
      console.log('URL:', API_URL);
      console.log('Token configurado:', API_TOKEN ? 'Sí' : 'No');
      
      if (!API_URL || !API_TOKEN) {
        throw new Error('Variables de entorno no configuradas correctamente');
      }

      // Hacer una petición simple para probar la conexión
      const response = await axios.get(`${API_URL}/layouts`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${API_TOKEN}`
        },
        timeout: 10000 // 10 segundos de timeout
      });

      console.log('✅ Conexión exitosa con FileMaker');
      console.log('Status:', response.status);
      console.log('Layouts disponibles:', response.data?.response?.layouts?.length || 0);
      
      return {
        success: true,
        status: response.status,
        message: 'Conexión exitosa',
        layouts: response.data?.response?.layouts || []
      };
      
    } catch (error) {
      console.error('❌ Error de conexión con FileMaker:', error);
      
      let errorMessage = 'Error desconocido';
      let errorCode = null;
      
      if (error.response) {
        errorCode = error.response.status;
        errorMessage = error.response.data?.messages?.[0]?.message || `Error HTTP ${errorCode}`;
        
        console.log('Detalles del error:');
        console.log('- Status:', error.response.status);
        console.log('- Data:', error.response.data);
        console.log('- Headers:', error.response.headers);
      } else if (error.request) {
        errorMessage = 'No se pudo conectar con el servidor';
        console.log('Error de red:', error.message);
      } else {
        errorMessage = error.message;
      }
      
      return {
        success: false,
        error: errorCode,
        message: errorMessage,
        details: error.response?.data || error.message
      };
    }
  }

  /**
   * Prueba el acceso a un layout específico
   */
  async testLayoutAccess(layoutName) {
    try {
      console.log(`🔍 Probando acceso al layout: ${layoutName}`);
      
      const response = await axios.get(`${API_URL}/layouts/${layoutName}/records?_limit=1`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${API_TOKEN}`
        },
        timeout: 10000
      });

      console.log(`✅ Acceso exitoso al layout ${layoutName}`);
      
      return {
        success: true,
        layout: layoutName,
        recordCount: response.data?.response?.dataInfo?.foundCount || 0,
        message: 'Acceso exitoso al layout'
      };
      
    } catch (error) {
      console.error(`❌ Error accediendo al layout ${layoutName}:`, error);
      
      return {
        success: false,
        layout: layoutName,
        error: error.response?.status,
        message: error.response?.data?.messages?.[0]?.message || error.message
      };
    }
  }

  /**
   * Ejecuta una batería completa de pruebas
   */
  async runFullTest() {
    console.log('🚀 Iniciando pruebas completas de FileMaker...');
    
    const results = {
      connection: null,
      layouts: {}
    };

    // Prueba de conexión básica
    results.connection = await this.testConnection();
    
    if (results.connection.success) {
      // Probar layouts específicos
      const layoutsToTest = [
        process.env.REACT_APP_FILEMAKER_LAYOUT_FAMILIAS,
        process.env.REACT_APP_FILEMAKER_LAYOUT_PLANES,
        process.env.REACT_APP_FILEMAKER_LAYOUT_URLS
      ].filter(Boolean);

      for (const layout of layoutsToTest) {
        results.layouts[layout] = await this.testLayoutAccess(layout);
      }
    }

    // Resumen de resultados
    console.log('📊 Resumen de pruebas:');
    console.log('- Conexión:', results.connection.success ? '✅' : '❌');
    
    Object.entries(results.layouts).forEach(([layout, result]) => {
      console.log(`- Layout ${layout}:`, result.success ? '✅' : '❌');
    });

    return results;
  }
}

export default new FileMakerTestService();